module.exports = __webpack_public_path__ + "img/wind_heavy.d2ba364e.svg";